import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps } from "@client/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type ContactForm } from "../types";

export type MapProps = RootContainerProps & {
  buttonCaption: string;
  isSending: boolean;
};

export type ActionProps = {
  onClick: (data: ContactForm.FormData) => void;
};

type OwnProps = ActionProps & MapProps;
type Props = FormButtonProps & OwnProps;
export default (props: Props) => {
  const i18n = useI18n();

  if (props.isSending) {
    return (
      <ModuleButton {...getRootContainerProps(props)} isDisabled>
        <i className="far fa-circle-o-notch fa-spin" /> {i18n.sending}
      </ModuleButton>
    );
  }

  return (
    <ModuleButton {...getRootContainerProps(props)} onClick={props.ifValidated(props.onClick)}>
      <props.TextComponent {...getEntityRef(props)} toolbar={"none"} html={props.buttonCaption} />
    </ModuleButton>
  );
};
